import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
// rest client
import {eapiClient} from '../../../../restClient';
// action creator
import { setAdminTabIndex } from '../../actions/actionCreator';
// utils
import {Translations, convertStringToArray} from '../../../../utils';
// children
import Filter from './Grid/Filter';
import ReactTable from './Grid/Table/';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../../common/Modal';
// style
import './style.css'

class GroupAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.GridData,
            filterData:this.props.GridData,
            deletedGroup:[],
            showDeleteModal: false,
            checkedGroupList: [],
            showGroupName: [],
            checkedValues:[]
        };
        this.grD = [];
    }

    componentDidMount(){
      this.props.setAdminTabIndex(1);
    }

    translations = (text) => {
      return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }

    translateWord = (word) => {
      var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
      var convertedArray = convertStringToArray(currentWord);
      return convertedArray;
    }


    toggleGroupDialog = () => {
      this.setState({
        showDeleteModal: false
      })
    }

    searchItmeHander = (str) => {
      if(str.length > 0 ) {
        let filterobject = this.state.data.filter(function(obj) {
            if (typeof obj.group !== 'undefined' && obj.group.toString().toLowerCase().indexOf(str.toString().toLowerCase()) !== -1 ) {
                return obj;
            }
        });
        this.setState({
          data: filterobject
        })
      } else if( str.length === 0){
        this.setState({
          data: this.state.filterData
        })
      }
    }

    getStatusOnchange = (statusStr) => {
        if (statusStr.length > 0 && statusStr !== 'All open cases') {
            let filterobject = this.props.GridData.filter(function(obj) {
                if (obj.group === statusStr) {
                    return obj;
                }
            });

            this.setState({
              data: filterobject
            })

        } else {
            this.setState({
              data: this.props.GridData,
              filterData: []
            })
        }
    }

    columnsHeader = () => {
        let columns = []
        let optionsData;
        var options = Translations(this.props.pageJson.table_groupAdmin.fieldLabels,this.props.lang.currentLang.lang, this.props.lang.translatedData);
        var ids = this.props.pageJson.table_groupAdmin.fields;
        optionsData = convertStringToArray(options)
        ids.map((item, index) => {
          columns.push({
            accessor: item,
            Header: optionsData[index],
            sortable: item === 'group' ? true : false
            })

        })
        return columns;
    }

    rowLink =(data) =>{
      if(this.props.rowLinkGls){
        this.props.setAdminTabIndex(1);
        this.props.rowLinkGls(data)
      }
    }

    checkGroup = (data) => {
      if(!this.grD.find(item => data.id === item.id) && data.checked !== false) {
        this.grD.concat(data)
      }
    }

    selectedGroup = (event,data) => {
      this.setState({
        checkedGroupList: data
      })
    }

    creteGroup = () => {
      this.props.history.push('/admin-panel/create-group/')
    }

    resetAll = () => {
      this.setState({
        data: this.state.filterData
      })
    }

    openDialogForDeletion = () => {
      var grData = []
      // var listOfGroup = this.state.checkedGroupList.map(item => {
      //   this.state.data.map(group => {
      //     if(item === group.id){
      //       grData.push(group.group)
      //     }
      //   })
      // })

      this.setState({
        showDeleteModal: true,
        showGroupName: grData
      })
    }

    deleteMultipleGroup = () => {
      let payload = new setDeletedGroup()
      payload.setPayLoad(this.state);
      eapiClient("/usergroup/bulkupdate", {
        method: 'PUT',
        data: JSON.stringify(payload.data)
      }).then(({data}) => {
        this.setState({
          data: data.responseData,
          showDeleteModal:false,
          filterData: data.responseData,
          checkedGroupList:[],
          checkedValues:[]
        })
        this.props.setAdminTabIndex(1);
      });
    }

    render() {
      return (
        <div>
            <div className="gdoc-caselist-grid">
              <div className="create-group-section">
                <button className="create-group-btn" onClick={this.creteGroup}><i className="icon icon-add"></i>{this.translations(this.props.pageJson.button_createGroup.text)} </button>
              </div>
              <div className="gdocs-clear-both"></div>
              <div>
                <Filter
                  pageJson={this.props.pageJson}
                  searchItmeHander={(str) => this.searchItmeHander(str)}
                  showFilters={false}
                  serchTitleHeader={this.props.pageJson.table_groupAdmin.filterTitle}
                  clearAll={this.resetAll}
                  clearFilterText={this.props.pageJson.table_groupAdmin.clearFilterText}
                  lang={this.props.lang}
                />
                <ReactTable
                  data = {this.state.data}
                  columns = {this.columnsHeader()}
                  pageJsonContent = {this.props.pageJson.table_groupAdmin}
                  isCaseList = {true}
                  defaultPageSize = {20}
                  rowLink = {(data)=> this.rowLink(data)}
                  className = "-striped -highlight"
                  checkGroup = {(data) => this.checkGroup(data)}
                  selectedGroup = {(event,data) => this.selectedGroup(event,data)}
                  lang={this.props.lang}
                  sortable={false}
                  isCheckbox={true}
                />
              </div>
              {
                this.props.deleteGroupJson !== undefined
                  ? <Modal
                      show={this.state.showDeleteModal}
                      onClose={this.toggleGroupDialog}
                      bsClass="delete-group-model"
                    >
                      <ModalHeader title={`${this.translations(this.props.deleteGroupJson.page_title_mainTitle.pageHeading)}: ${this.state.showGroupName.join(',')}`} />
                      <ModalBody>
                        {
                          this.translations(this.props.deleteGroupJson.page_title_mainTitle.descriptionText)
                        }
                      </ModalBody>
                      <ModalFooter>
                        <div className="delete-group-model--body">
                          <div className="gdocs-float-left">
                            <button className="gdocs-btn-delete" onClick={this.toggleGroupDialog}>{this.translations(this.props.deleteGroupJson.button_doNotDelete.text)}</button>
                          </div>
                          <div className="gdocs-float-right">
                            <button className="gdocs-btn-primary" onClick={this.deleteMultipleGroup}>{this.translations(this.props.deleteGroupJson.button_deleteGroup.text)}</button>
                          </div>
                        </div>
                      </ModalFooter>
                    </Modal>
                  :''
              }
              <div className="create-group-section delete-groups-section">
                <button className="create-group-btn" onClick={this.openDialogForDeletion}>{this.translations(this.props.pageJson.button_deleteGroup.text)}</button>
              </div>
            </div>
          </div>
        );
    }
}

class setDeletedGroup {
  constructor(){
    this.data = {}
  }
  setPayLoad({checkedGroupList}){
    this.data = {
      data: [...checkedGroupList]
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setAdminTabIndex: index => {
      dispatch(setAdminTabIndex(index))
    }
  }
}

GroupAdmin.defaultProps = {
    caseSatus: []
}
GroupAdmin.propTypes = {
    data: PropTypes.array
};

export default connect(null,mapDispatchToProps)(GroupAdmin)



// WEBPACK FOOTER //
// ./src/components/Admin/AdminPanel/SubComp/GroupAdmin.js